<template>
  <h2 :class="['section-title-overlay', `is-${variant}`]" :style="boxStyle">{{ title }}</h2>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import type { CSSProperties } from 'vue'

import type { DesignBox } from '../../data/home2026'

type SectionTitleVariant = 'about' | 'creator'

const props = withDefaults(defineProps<{
  box: DesignBox
  scaledPx: (value: number) => string
  title: string
  variant?: SectionTitleVariant
}>(), {
  variant: 'about',
})

const titleMetrics = computed(() =>
  props.variant === 'creator'
    ? { font: 70, line: 98 }
    : { font: 50, line: 70 },
)

const boxStyle = computed<CSSProperties>(
  () =>
    ({
      left: props.scaledPx(props.box.x),
      top: props.scaledPx(props.box.y),
      width: props.scaledPx(props.box.w),
      height: props.scaledPx(props.box.h),
      '--section-title-font': props.scaledPx(titleMetrics.value.font),
      '--section-title-line': props.scaledPx(titleMetrics.value.line),
    }) as CSSProperties,
)
</script>

<style scoped>
.section-title-overlay {
  position: absolute;
  z-index: 3;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0;
  overflow: visible;
  color: #fff;
  font-size: var(--section-title-font);
  font-synthesis: none;
  line-height: var(--section-title-line);
  letter-spacing: 0;
  pointer-events: none;
  -webkit-font-smoothing: antialiased;
  text-rendering: geometricprecision;
}

.section-title-overlay.is-about {
  justify-content: flex-start;
  font-family: AlibabaPuHuiTi_3_65_Medium, 'Alibaba PuHuiTi 3.0', PingFangSC-Regular, Source Han Sans CN, sans-serif;
  font-weight: 500;
  text-align: left;
  white-space: nowrap;
}

.section-title-overlay.is-creator {
  justify-content: center;
  font-family: AlibabaPuHuiTi_3_115_Black, 'Alibaba PuHuiTi 3.0', PingFangSC-Regular, Source Han Sans CN, sans-serif;
  font-weight: 1000;
  text-align: center;
  white-space: normal;
}
</style>
